export const CREATE_POPAP_NOTIFICATION_REQUEST = "CREATE_POPAP_NOTIFICATION_REQUEST"
export const CREATE_POPAP_NOTIFICATION_REQUEST_SUCCESS = "CREATE_POPAP_NOTIFICATION_REQUEST_SUCCESS"
export const UPDATE_POPAP_STATUS_REQUEST = "UPDATE_POPAP_STATUS_REQUEST"
export const GET_POPAP_STATUS_REQUEST = "GET_POPAP_STATUS_REQUEST"
export const GET_POPAP_STATUS_REQUEST_SUCCESS = "GET_POPAP_STATUS_REQUEST_SUCCESS"

